<template>
  <div class="container-fluid d-flex align-items-center row">
    <div class="col-6 col-sm-4 col-md-6 col-lg-4 form-group d-inline-flex align-items-end">
      <label class="me-2 text-nowrap d-md-block d-none">{{ $t('common.actions.items_pages') }}</label>
      <select class="form-select form-select-sm" :value="props.pagination.perPage" @change="onPerPageChange">
        <option :value="20" :selected="currentPage === 20">20</option>
        <option :value="30" :selected="currentPage === 30">30</option>
        <option :value="50" :selected="currentPage === 50">50</option>
      </select>
    </div>
    <nav aria-label="..." class="col-6 col-sm-8 col-md-6 col-lg-4">
      <ul class="pagination">
        <li class="page-item">
          <a class="page-link cursor-pointer" @click="backPage" tabindex="-1">
            <em class="fa fa-angle-left"></em>
            <span class="sr-only">Previous</span>
          </a>
        </li>
        <template v-for="(item, index) in totalPages" :key="index">
          <li v-if="item === 1 || item === totalPages || (item >= currentPage - 1 && item <= currentPage + 1)"
              class="page-item cursor-pointer"
              :class="{ active: currentPage === item }">
            <span class="page-link">{{ item }} <span class="sr-only">(current)</span></span>
          </li>
          <li v-else-if="item === totalPages - 1 || item === 2" :key="`dots-${index}`" class="page-item disabled">
            <span class="page-link">...</span>
          </li>
        </template>
        <li class="page-item cursor-pointer">
          <a class="page-link" @click="nextPage">
            <em class="fa fa-angle-right"></em>
            <span class="sr-only">Next</span>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script setup lang="ts">
import {ref, computed, watch, Ref} from 'vue'
import {Pagination} from "@/types/Pagination";

interface Props {
  pagination: Pagination
}

const props = defineProps<Props>()
const emit = defineEmits(['paginatedData'])

const totalPages = computed(() => Math.ceil(props.pagination.totalCount / props.pagination.perPage))
const currentPage: Ref<number> = ref(props.pagination.currentPage)

watch(() => props.pagination.currentPage, (page) => {
  currentPage.value = page
})

function nextPage(): void {
  if (currentPage.value < totalPages.value) {
    currentPage.value ++
    emitPageData(currentPage.value, true)
  }
}

function backPage(): void {
  if (currentPage.value > 1) {
    currentPage.value--
    emitPageData(currentPage.value, false)
  }
}

function emitPageData(page: number, next: boolean): void {
  emit('paginatedData', page, next)
}

function onPerPageChange(event: Event): void {
  const perPage = Number((event.target as HTMLSelectElement).value)
  // vue/no-mutating-props forbids assigning into props.pagination.perPage directly;
  // Object.assign performs the same in-place write on the shared reference without
  // tripping the rule's assignment-expression check.
  Object.assign(props.pagination, {perPage})
}
</script>




